export default __webpack_public_path__ + "0ae4544569473907bd787e928ef19b0d.png";